<!--
 * @ Author: Clark
 * @ Create Time: 2023-02-05 20:20:57
 * @ Modified by: Your name
 * @ Modified time: 2023-03-03 11:00:55
 * @ Description: 司机管理>平台内部司机>子公司管理列表 
 -->

<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="motorcade-main-account">
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons">
        <template #headerButtons>
          <div class="table-header-button">
            <template v-for="(btn, i) in pageButtons">
              <ykc-button :type="btn.type" v-if="btn.enabled()" :key="i" @click="btn.handleClick">
                {{ btn.text }}
              </ykc-button>
            </template>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
    <ykc-drawer
      :show.sync="showDrawer"
      :title="drawerTitle"
      :on-close="onAddDrawerClose"
      :before-cancel="onAddDrawerCancel"
      ensure-txt="保存">
      <template #footer>
        <div class="drawer-button-wrap">
          <template v-for="(btn, i) in drawerButtons">
            <ykc-button :type="btn.type" v-if="btn.enabled()" :key="i" @click="btn.handler">
              {{ btn.label }}
            </ykc-button>
          </template>
        </div>
      </template>
      <div class="drawer-main-body" v-if="showDrawer">
        <ImportData ref="addOrEdit" v-if="drawerType === 'import'"></ImportData>
        <AddOrEdit
          v-if="drawerType === 'edit'"
          ref="addOrEdit"
          :id="String(id)"
          :isEdit="isEdit"></AddOrEdit>
      </div>
    </ykc-drawer>
  </scroll-layout>
</template>

<script>
  import YkcDialog from '@/components/ykc-ui/dialog/index';
  import AddOrEdit from './AddOrEdit.vue';
  import ImportData from './ImportData.vue';
  import { internalOrg, customerOrg } from '@/service/apis';
  import { offlineExport, code } from '@/utils';

  export default {
    name: 'MotorcadeMainAccountList',
    components: {
      AddOrEdit,
      ImportData,
    },
    data() {
      return {
        drawerType: '',
        isEdit: false,
        showDrawer: false,
        mainOrgList: [],
        allOrgList: [],
        drawerButtons: [
          {
            label: '取消',
            type: 'plain',
            enabled: () => true,
            handler: () => {
              YkcDialog({
                dialogType: 'feedback',
                showTitle: false,
                showFooter: true,
                desc: '取消后操作将不被保存，确认是否取消？',
                onCancel: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                },
                onConfirm: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                  this.showDrawer = false; // 隐藏抽屉
                },
              });
            },
          },
          {
            label: '保存',
            enabled: () => true,
            handler: () => {
              this.$refs.addOrEdit.submitForm().then(() => {
                this.showDrawer = false;
                this.searchTableList();
              });
            },
          },
        ],
        pageButtons: [
          {
            id: '0',
            text: '批量新增',
            type: 'plain',
            enabled: () => code('internal:org:batch'),
            handleClick: () => {
              this.doImportFile();
            },
          },
          {
            id: '1',
            text: '新增',
            type: 'plain',
            enabled: () => code('internal:org:add'),
            handleClick: () => {
              this.add();
            },
          },
          {
            id: '2',
            text: '导出',
            type: 'plain',
            enabled: () => code('internal:org:export'),
            handleClick: () => {
              this.doExportFile();
            },
          },
        ],
        tableData: [],
        tableTitle: '子公司列表',
        tableColumns: [
          { label: this.$t('子公司编码'), prop: 'id', minWidth: '100px' },
          { label: '机构名称', prop: 'name', minWidth: '100px' },
          { label: '统一社会信用代码', prop: 'socialCreditCode', minWidth: '100px' },
          { label: '上级公司', prop: 'parentName', minWidth: '100px' },
          { label: '联系人', prop: 'manageName', minWidth: '100px' },
          { label: '联系方式', prop: 'contactInfo', minWidth: '100px' },
        ],
        tableOperateButtons: [
          {
            render: (h, data, { row }) =>
              code('internal:org:edit') ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.isEdit = true;
                    this.showDrawer = true;
                    this.showAddDrawer = true;
                    this.id = row.id;
                    this.drawerType = 'edit';
                  }}>
                  {'编辑'}
                </ykc-button>
              ) : null,
          },
          {
            render: (h, data, { row }) =>
              code('internal:org:finance') ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.toFinance(row);
                  }}>
                  {'财务'}
                </ykc-button>
              ) : null,
          },
        ],
        pageInfo: {
          current: 0,
          size: 10,
        },
        searchParams: {
          orgMold: 2,
          name: '',
          socialCreditCode: '',
          mainOrgName: '',
          operatorName: '',
          manageName: '',
          parentId: '',
          endDcontactInfote: '',
        },
      };
    },
    created() {
      this.searchTableList();
      this.queryCompanyAllOrgList();
      this.queryCompanyMainOrgList();
    },
    computed: {
      drawerTitle() {
        if (this.drawerType === 'import') {
          return '批量导入';
        }
        return `子公司${this.isEdit ? '编辑' : '新增'}`;
      },
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'name',
            label: '机构名称',
            placeholder: '请输入机构名称',
          },
          {
            comName: 'YkcInput',
            key: 'socialCreditCode',
            label: '统一社会信用代码',
            placeholder: '请输入统一社会信用代码',
          },
          {
            comName: 'YkcDropdown',
            key: 'parentId',
            label: '上级公司',
            placeholder: '请输入上级公司',
            data: this.allOrgList,
            remote: true,
          },
          {
            comName: 'YkcInput',
            key: 'manageName',
            label: '联系人',
            placeholder: '请输入联系人',
          },
          {
            comName: 'YkcInput',
            key: 'contactInfo',
            label: '联系方式',
            placeholder: '请输入联系方式',
          },
        ];
      },
    },
    methods: {
      toFinance(row) {
        this.$router.push({
          path: '/financialManagement/subsidiaryAccount/internalCustomerAccountsDetail',
          query: {
            id: row.id,
          },
        });
      },
      detailLink(row) {
        this.$router.push({
          path: '/marketingCenter/labelUsers/details',
          query: {
            id: row.id,
          },
        });
      },
      contractDetailLink(row) {
        this.$router.push({
          path: '/marketingCenter/labelUsers/details',
          query: {
            id: row.contractId,
          },
        });
      },
      // 获取子公司所有机构下拉数据
      queryCompanyAllOrgList() {
        customerOrg.queryCompanyAllOrgList({}).then(res => {
          this.allOrgList = res;
        });
      },
      // 获取子公司主机构下拉数据
      queryCompanyMainOrgList() {
        customerOrg.queryCompanyMainOrgList({}).then(res => {
          this.mainOrgList = res;
        });
      },
      add() {
        this.showAddDrawer = true;
        this.isEdit = false;
        this.id = '';
        this.drawerType = 'edit';
        this.showDrawer = true;
      },
      handleSpecialCountClick(row) {
        const routeUrl = this.$router.resolve({
          path: '/priceConfig/specialPurchasePrice',
          query: {
            stationId: row.stationId,
          },
        });
        window.open(routeUrl.href, '_blank');
      },
      changeStateSearch() {
        this.pageInfo.current = 0;
        this.searchTableList();
      },
      /** 根据条件查询数据 */
      searchTableList() {
        Promise.all([
          internalOrg.list({
            ...this.pageInfo,
            ...this.searchParams,
            orgMold: '2',
            userType: '3',
            carType: '3',
          }),
        ]).then(([res1]) => {
          this.tableData = res1.records;
          this.pageInfo.total = res1.total || 0;
        });
      },
      /**
       * @desc 导出文件 - 车队主账号列表
       * */
      doExportFile() {
        console.log('doExport');
        offlineExport(
          {
            downloadType: 'company_org',
            jsonNode: {
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      /** 批量导入文件 */
      doImportFile() {
        this.drawerType = 'import';
        this.isEdit = true;
        this.showDrawer = true;
      },
      onAddDrawerClose(done) {
        done();
      },
      /**
       * @desc 点击抽屉取消按钮 callback
       * */
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            done();
            drawerDone();
            if (this.isEdit) {
              this.isEdit = false;
            }
          },
        });
      },
      /**
       * @desc 点击页面左上角按钮 callback
       * */
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(form) {
        this.pageInfo.current = 0;
        Object.assign(this.searchParams, form);
        this.searchTableList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        console.log(JSON.stringify(this.searchParams));
        console.log(JSON.stringify(form));
        Object.assign(this.searchParams, form);
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.searchTableList();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.searchTableList();
      },
      /**
       * 重置 form data
       * */
      resetFormData() {
        this.ruleForm = {
          orgMold: 2,
          name: '',
          socialCreditCode: '',
          mainOrgName: '',
          operatorName: '',
          manageName: '',
          endDcontactInfote: '',
        };
      },
    },
  };
</script>
<style lang="scss" scoped>
  .link {
    color: blue;
    cursor: pointer;
  }
  .el-radio-group .item {
    border: 0;
  }
</style>
